module.exports = __webpack_public_path__ + "img/app_icon.2086b84e.png";